import { Alert, Box, CircularProgress, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getMhdApartment, getMhdProfile } from "src/apis/controllers/mhdProfile";
import {
  ApartmentCard,
  BeneficiaryFilter,
  ProfileHeader,
} from "./ProfileComponents";

const ApartmentProfile = () => {
  const { applicationId, apartmentId } = useParams();
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [apartment, setApartment] = useState(null);
  const [filter, setFilter] = useState("current");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    setLoading(true);
    Promise.all([
      getMhdProfile(applicationId),
      getMhdApartment(applicationId, apartmentId),
    ])
      .then(([profileResponse, apartmentResponse]) => {
        if (!active) return;
        if (
          profileResponse?.succeeded === false ||
          apartmentResponse?.succeeded === false ||
          !profileResponse?.data ||
          !apartmentResponse?.data
        ) {
          setError(
            apartmentResponse?.message ||
              profileResponse?.message ||
              "Δεν βρέθηκε το διαμέρισμα.",
          );
          return;
        }
        setProfile(profileResponse.data);
        setApartment(apartmentResponse.data);
      })
      .catch((requestError) => {
        if (active) {
          setError(requestError?.message || "Δεν φορτώθηκε το διαμέρισμα.");
        }
      })
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [applicationId, apartmentId]);

  if (loading) {
    return <Box sx={{ minHeight: 320, display: "grid", placeItems: "center" }}><CircularProgress /></Box>;
  }

  if (error || !profile || !apartment) {
    return <Alert severity="error" sx={{ m: 3 }}>{error || "Δεν βρέθηκε το διαμέρισμα."}</Alert>;
  }

  return (
    <Box sx={{ p: { xs: 1.5, md: 2 }, maxWidth: 1600, mx: "auto" }}>
      <ProfileHeader
        profile={profile}
        apartment={apartment}
        onBack={() => navigate(`/govnr/mhds/${applicationId}`)}
      />
      <Stack spacing={2}>
        <Stack direction="row" justifyContent="flex-end">
          <BeneficiaryFilter value={filter} onChange={setFilter} />
        </Stack>
        <ApartmentCard
          apartment={apartment}
          applicationId={applicationId}
          mhdName={profile.name}
          filter={filter}
          showOpen={false}
        />
      </Stack>
    </Box>
  );
};

export default ApartmentProfile;
